import service from './axios';

// 获取支持的物流公司列表
export const fetchExpressCompanies = () => {
  return service({
    method: 'get',
    url: '/manage/express-companies'
  });
};

// 从微信同步物流公司列表
export const syncExpressCompaniesFromWechat = () => {
  return service({
    method: 'post',
    url: '/manage/express-companies/sync-from-wechat'
  });
};

// 更新物流公司启用状态
export const updateExpressCompanyStatus = (id) => {
  return service({
    method: 'patch',
    url: `/manage/express-companies/${id}/status`
  });
};

// 获取已配置的物流账户
export const getConfiguredExpressAccounts = () => {
  return service({
    method: 'get',
    url: '/manage/express-companies/configured-accounts'
  });
};
